export const DIAGNOSTICS_FEATURE_SWITCH_KEY = 'feature-diagnostics';

export function isDiagnosticsFeatureEnabled(): boolean {
  return localStorage.getItem(DIAGNOSTICS_FEATURE_SWITCH_KEY) === 'true';
}
